import { ScreenWidth } from './Dimension'
import { WEB, TABLET } from './../config/constants'
export function Checkdevicedetail(wtinbtw = false) {
    const W = ScreenWidth()
    if (W > WEB) {
        return 'WEB'
    }
    else if (wtinbtw && W > 900) {
        return 'WTINBTW'
    }
    else if (W > TABLET) {
        return 'TABLET'
    }
    else if (W > 470) {
        return 'SMALLTABLET'
    }
    else {
        return 'MOBILE'
    }
}